// extracted by css-extract-rspack-plugin
export default {"item":"item-GoSIaR","type":"type-Fgjf3e"};